<template>
  <v-container id="page-business-log">
    <div class="page-title">{{$route.name}}</div>
    <v-row>
      <v-col cols="12" md="2" sm="2">
        <c-btn color="blue" outlined iconName="file_download" @click="downloadExcelDialog = true">데이터 내려받기</c-btn>
        <vue-excel-xlsx
          id="excelDownloadButton1"
          :data="tableData"
          :columns="excelColumns1"
          :filename="excelFilename1"
          :sheetname="'차량운행일보'"
          />
        <vue-excel-xlsx
          id="excelDownloadButton2"
          :data="tableData"
          :columns="excelColumns2"
          :filename="excelFilename2"
          :sheetname="'수입일지'"
          />
      </v-col>
      <v-col cols="12" md="10" sm="10">
        <v-row justify="end" class="mr-2">
          <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div style="width: 200px">
                <v-text-field
                  v-model="startDate"
                  label="시작일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </div>
            </template>
            <c-date-picker v-model="startDate" @input="startMenu = false" firstDayOfWeek="1" :selectedDate="startDate"></c-date-picker>
          </v-menu>
          <v-menu
            v-model="endMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div style="width: 200px">
                <v-text-field
                  v-model="endDate"
                  label="종료일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </div>
            </template>
            <c-date-picker v-model="endDate" @input="endMenu = false" firstDayOfWeek="1" :selectedDate="endDate"></c-date-picker>
          </v-menu>
          <v-menu
            v-model="tableMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div style="width: 200px">
                <v-select
                  v-model="table"
                  :items="tables"
                  item-text="name"
                  item-value="no"
                  menu-props="{ offsetY: true}"
                  prepend-icon="library_books"
                  hide-details
                  label="업무일지 종류"
                  color="navy"
                ></v-select>
              </div>
            </template>
          </v-menu>
        </v-row>
      </v-col>
    </v-row>
    <c-card outlined class="mb-3">
      <div class="page-title mb-3 font-weight-bold">주행 누적 통계</div>
      <v-row>
        <v-col cols="12" md="2" sm="2">
          <span class="title">주행 건수(건)</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="display-1"> {{ Number(this.counts.drive).toLocaleString() }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="title">주행 거리(km)</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="display-1"> {{ displayTotalDistance(this.counts.distance).toLocaleString() }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="title">평균 주행 거리(km)</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="display-1"> {{ this.counts.drive > 0 ? Number(displayTotalDistance(this.counts.distance) / this.counts.drive).toFixed(2).toLocaleString() : 0 }}</span>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" md="2" sm="2">
          <span class="title">탑승 인원(명)</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="display-1"> {{ Number(this.counts.rider).toLocaleString() }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="title">이용 시간</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <div class="display-1">{{ this.counts.totalTime ? displayDuration(this.counts.totalTime) : 0 }}</div>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="title">주유 총량 (L)</span><br>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="display-1"> {{ this.totalRefueling ? Number(this.totalRefueling).toLocaleString() : 0 }}</span>
        </v-col>
      </v-row>
    </c-card>
    <c-card outlined class="mb-3">
      <div class="page-title mb-3 font-weight-bold">요금 통계</div>
      <v-row justify="center">
        <v-col cols="12" md="2" sm="2">
          <span class="title">실 결제요금(원)</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="display-1"> {{ Number(this.counts.paidFee).toLocaleString() }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="title">미수금(원)</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <div class="red--text display-1" @click="onlyUnpaid = !onlyUnpaid" v-ripple style="display:inline-block;">{{ Number(this.counts.unpaidFee).toLocaleString() }}</div>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="title">총 수입금(원)</span><br>
          <span class="">(실 결제요금 + 미수금)</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="display-1"> {{ Number(this.counts.totalFee).toLocaleString() }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <span class="page-title font-weight-bold">결제 수단에 따른 요금 합계</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="2" sm="2">
          <span class="title">현금(원)</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="display-1"> {{ Number(this.money.cash).toLocaleString() }}</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="title">카드(원)</span>
        </v-col>
        <v-col cols="12" md="2" sm="2">
          <span class="display-1"> {{ Number(this.money.card).toLocaleString() }}</span>
        </v-col>
      </v-row>
    </c-card>

    <template v-if="table == 1">
      <c-card title="차량운행일보">
        <template #headItems>
          <v-text-field
            v-model="keyword"
            append-icon="mdi-magnify"
            label="차량번호, 기사이름"
            single-line
            hide-details
            maxlength="32"
          ></v-text-field>
        </template>
        <c-table
          :headers="tableHeader1" :items="tableData" multi-sort>
          <template #drivePeriod="{item}">
            {{ item.startHrMin }}<br>
            {{ item.endHrMin }}
          </template>
          <template #addr="{item}">
            {{ item.addr0 }}<br>
            {{ item.addr1 }}
          </template>
          <template #itemDistance="{ item }">
            {{ displayItemDistance(item.itemDistance).toFixed(3) }}
          </template>
          <template #totalFeeDisplay="{item}">
            {{ Number(item.totalFee).toLocaleString() }}
          </template>
        </c-table>
      </c-card>
    </template>

    <template v-if="table == 2">
      <c-card title="수입일지">
        <template #headItems>
          <v-text-field
            v-model="keyword"
            append-icon="mdi-magnify"
            label="차량번호, 기사이름"
            single-line
            hide-details
            maxlength="32"
          ></v-text-field>
        </template>
        <c-table :headers="tableHeader2" :items="tableData" multi-sort>
          <template #totalPaidFeeDisplay="{item}">
            {{ Number(item.totalPaidFee).toLocaleString() }}
          </template>
          <template #unpaidFeeDisplay="{item}">
            {{ Number(item.unpaidFee).toLocaleString() }}
          </template>
          <template #totalFeeDisplay="{item}">
            {{ Number(item.totalFee).toLocaleString() }}
          </template>
        </c-table>
      </c-card>
    </template>
    <download-excel-dialog
      :open.sync="downloadExcelDialog"
      @reqDownloadExcel="reqDownloadExcel"
    />
  </v-container>
</template>

<script>
  import DownloadExcelDialog from "../Common/DownloadExcelDialog";
  import VueExcelXlsx from "vue-excel-xlsx";
  import Vue from "vue";

  Vue.use(VueExcelXlsx);

  export default {
    components: {
      DownloadExcelDialog
    },
    data() {
      return {
        startDate: this.$func.curDateStringAddDays(-7),
        endDate: this.$func.curDateString(),
        totalRefueling: 0,
        counts: {
          drive: 0,
          distance: 0,
          rider: 0,
          paidFee: 0,
          unpaidFee: 0,
          totalFee: 0,
          totalTime: 0,
        },
        money: {
          card: 0,
          cash: 0
        },
        startMenu: false,
        endMenu: false,
        tableMenu: false,
        downloadExcelDialog: false,
        table: 1,
        tables: [
          {no:1, name: "차량운행일보"},
          {no:2, name: "수입일지"}
        ],
        keyword:"",
        onlyUnpaid:false,
        tableHeader1: [
          { text:'날짜', value: 'driveDate', align: 'center', sortable: true, },
          { text:'차량번호', value: 'plateNo', align: 'center', sortable: true, },
          { text:'차량모델', value: 'modelName', align: 'center', sortable: true, },
          { text:'기사이름', value: 'driverName', align: 'center', sortable: true, },
          { text:'총 주행 시간', value: 'drivePeriod', align: 'center', sortable: true, },
          { text:'주행구간', value: 'addr', align: 'center', sortable: false, },
          { text:'출발지', value: 'addr0', align: ' d-none', sortable: false, },
          { text:'도착지', value: 'addr1', align: ' d-none', sortable: false, },
          { text:'주행거리(km)', value: 'itemDistance', align: 'center', sortable: false, },
          { text:'예약자', value: 'customerName', align: 'center', sortable: false, },
          { text:'탑승인원(명)', value: 'riderCount', align: 'center', sortable: false, },
          { text:'최종 요금(원)', value: 'totalFeeDisplay', align: 'center', sortable: false, }
        ],
        tableHeader2: [
          { text:'날짜', value: 'driveDate', align: 'center', sortable: true, },
          { text:'기사명', value: 'driverName', align: 'center', sortable: true, },
          { text:'담당차량', value: 'plateNo', align: 'center', sortable: true, },
          { text:'실 결제요금(원)', value: 'totalPaidFeeDisplay', align: 'center', sortable: false,},
          { text:'미수금(원)', value: 'unpaidFeeDisplay', align: 'center', sortable: false, },
          { text:'최종 요금(원)', value: 'totalFeeDisplay', align: 'center', sortable: false, },
          { text:'결제 수단', value: 'payMethodName', align: 'center', sortable: false, }
        ],
        driveLog: [],
        tableData: [],
        excelColumns1 : [
          { label: "날짜", field: "driveDate", },
          { label: "차량번호", field: "plateNo" },
          { label: "차량모델", field: "modelName"},
          { label: "기사이름", field: "driverName" },
          { label: "출발시간", field: "startHrMin" },
          { label: "도착시간", field: "endHrMin" },
          { label: "출발지", field: "addr0" },
          { label: "도착지", field: "addr1" },
          { label: "주행거리(km)", field: "itemDistance" },
          { label: "예약자", field: "customerName" },
          { label: "탑승인원", field: "riderCount" },
          { label: "최종요금", field: "totalFee" }
        ],
        excelColumns2 : [
          { label: "날짜", field: "driveDate", },
          { label: "기사명", field: "driverName" },
          { label: "담당차량", field: "plateNo" },
          { label: "실 결제 요금(월)", field: "totalPaidFee" },
          { label: "미수금(원)", field: "unpaidFee" },
          { label: "최종 요금(원)", field: "totalFee" },
          { label: "결제 수단", field: "payMethodName" }
        ],
      }
    },
    watch: {
      startDate: function () {
        this.reqDriveLog();
        this.reqRefueling();
      },
      endDate: function () {
        this.reqDriveLog();
        this.reqRefueling();
      },
      table: function() {
        this.filterTableData();
      },
      keyword: function() {
        this.filterTableData();
      },
      onlyUnpaid: function() {
        this.filterTableData();
      },
    },
    computed: {
      excelFilename1() {
        if ( this.startDate == this.endDate ) {
          return "차량운행일보_"+this.startDate;
        } else {
          return "차량운행일보_"+this.startDate+"_"+this.endDate;
        }
      },
      excelFilename2() {
        if ( this.startDate == this.endDate ) {
          return "수입일지_"+this.startDate;
        } else {
          return "수입일지_"+this.startDate+"_"+this.endDate;
        }
      }
    },
    activated() {
      this.reqDriveLog();
      this.reqRefueling();
    },
    methods: {
      async reqDriveLog() {
        try {
          const res = await this.$api.getDriveLogStatusIsAndStartTimeBetween("ds_done", this.startDate, this.endDate);

          this.driveLog = res.data.map((item, idx) => {
            item.idx = idx;
            item.driveDate = item.startTime ? this.$func.dateToString(item.startTime) : '';
            item.driverName = item.driver.name;
            item.plateNo = item.vehicle.plateNo;
            item.modelName = item.vehicle.vehicleModel ? item.vehicle.vehicleModel.modelName : '--';
            item.startHrMin = this.displayTime(item.startTime);
            item.endHrMin = this.displayTime(item.endTime);
            item.totalPaidFee = item.totalFee;
            item.totalUnpaidFee = item.unpaidFee;
            item.payMethodName = item.payMethod ? item.payMethod.configName : '-';
            item.addr0 = item.reservationRouteList[0]?.position;
            item.addr1 = item.reservationRouteList[item.reservationRouteList.length-1]?.position;

            let distance = 0;
            if (item.selectedDistanceType) {
              switch (item.selectedDistanceType.configValue) {
                case 'sdt_obd':
                  distance = item.collectedTotalDistance;
                  break;
                case 'sdt_api':
                  distance = item.apiSupportedDistance;
                  break;
                default:
                  distance = item.totalDistance;
              }
            } else {
              distance = item.collectedTotalDistance != null ? item.collectedTotalDistance : item.totalDistance;
            }
            item.itemDistance = Number(distance);

            return item;
          });

          await this.filterTableData();
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqDriveLog'});
        }
      },
      async filterTableData() {
        this.tableData = [];
        this.counts = { drive: 0, distance: 0, rider: 0, totalTime : 0, paidFee: 0, unpaidFee: 0, totalFee: 0 };
        this.money = { card : 0, cash: 0 };

        this.driveLog.map((item, idx) => {
          if ( item.driverName.indexOf(this.keyword) > -1 || item.plateNo.indexOf(this.keyword) > -1 ) {
            if ( !this.onlyUnpaid || item.totalUnpaidFee != 0 ) {
              this.tableData.push(item);

              this.counts.drive++;
              this.counts.rider += item.riderCount;
              this.counts.paidFee += item.totalPaidFee;
              this.counts.unpaidFee += item.totalUnpaidFee;
              this.counts.totalFee += item.totalFee;
              this.counts.totalTime += item.driveDuration;
              let distance = 0;
              if (item.selectedDistanceType) {
                switch (item.selectedDistanceType.configValue) {
                  case 'sdt_api':
                    distance = item.apiSupportedDistance;
                    break;
                  case 'sdt_gps':
                    distance = item.totalDistance;
                    break;
                  default:
                    distance = item.collectedTotalDistance;
                }
              } else {
                distance = item.collectedTotalDistance != null ? item.collectedTotalDistance : item.totalDistance;
              }
              this.counts.distance += distance;

              let payMethodConfig = item.payMethod ? item.payMethod.configValue : '-';
              let extraPayMethodConfig = item.extraPayMethod ? item.extraPayMethod.configValue : '-';

              if ( payMethodConfig == "pm_cash" ) {
                this.money.cash += item.paidFee;
              } else if ( payMethodConfig == "pm_card" ) {
                this.money.card += item.paidFee;
              } else if ( item.paidFee ) {
                console.log(item);
              }

              if ( extraPayMethodConfig == "pm_cash" ) {
                this.money.cash += item.extraPaidFee;
              } else if ( extraPayMethodConfig == "pm_card" ) {
                this.money.card += item.extraPaidFee;
              } else if ( item.extraPaidFee ) {
                console.log(item);
              }
            }
          }
        });
      },
      async reqDownloadExcel() {
        document.getElementById("excelDownloadButton"+this.table).click();
        this.downloadExcelDialog = false;
      },
      async reqRefueling() {
        try {
          this.totalRefueling = 0;

          const res = await this.$api.getRefuelingBetween(this.startDate, this.endDate);

          res.data.map((item, idx) => {
            this.totalRefueling += parseInt(item.liter);
          });

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqRefueling'});
        }
      },
      displayTime(str) {
        return str ? this.$moment(str).format("HH:mm") : "";
      },
      displayPeriod(str0, str1) {
        return this.$moment(str0).format("HH:mm")+"~"+this.$moment(str1).format("HH:mm");
      },
      displayTotalDistance(distance) {
        return distance > 0 ? Math.round(distance * 1.0 / 10) / 100 : 0;
      },
      displayItemDistance(distance) {
        return distance > 0 ? Number(distance/1000):  0;
      },
      displayDuration(sec) {
        let hours   = Math.floor(sec / 3600);
        let minutes = Math.floor((sec - (hours * 3600)) / 60);

        return hours + '시간 ' + minutes + '분 '
      },
    }
  }
</script>

<style scoped>

.outline {
  outline: 1px solid black
}

</style>
